import styles from './no-equipment.module.scss';
import { useTranslations } from 'next-intl';
import AddEquipmentWidget from 'components/my-equipment/add-equipment-widget/add-equipment-widget';
import { UserDetailsProps } from '../../types';
import { NoActiveEquipmentMobile } from '../no-active-equipment-mobile';
import { FORM_LOCATION } from 'constants/analyticsConstants';
import { NO_EQUIPMENT } from 'components/request-equipment-service/constant';
import { Image } from 'components/image';

export const NoEquipment = ({
  isLoggedIn,
  isCspUser,
  storeId
}: UserDetailsProps) => {
  const t = useTranslations();

  return (
    <>
      <div className="d-none d-blg-block">
        <AddEquipmentWidget
          title={t('ADD_EQUIPMENT_DRAWER_HEADING')}
          isLoggedIn={isLoggedIn}
          showNotifyDealer={isCspUser}
          storeId={storeId}
          formLocation={FORM_LOCATION}
        >
          <div className={`${styles['no-equipment-image-height']} g-0 m-4`}>
            <Image
              src={NO_EQUIPMENT.IMAGE_URL}
              alt={NO_EQUIPMENT.ALT}
              loading="lazy"
              fill
              className={styles['no-equipment-image']}
            />
          </div>
        </AddEquipmentWidget>
      </div>
      <div className="d-blg-none d-md-block">
        <NoActiveEquipmentMobile />
      </div>
    </>
  );
};
